var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveSphereresized(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3403_29487)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3403_29487)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3403_29487)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 86,
    width: 78.8571,
    height: 78.8571,
    rx: 39.4286,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3403_29487)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.139,
    cy: 133.806,
    rx: 33.5143,
    ry: 31.05,
    fill: "#636980"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3403_29487)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.101,
    cy: 137.749,
    rx: 34.0071,
    ry: 34.9929,
    fill: "#E3E8FC"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.78,
    filter: "url(#filter3_f_3403_29487)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.925,
    cy: 114.585,
    rx: 42.8786,
    ry: 39.4286,
    fill: "#2D53DA"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 86.2688,
    y: 86.2688,
    width: 78.3195,
    height: 78.3195,
    rx: 39.1597,
    stroke: "#2D53DA",
    strokeWidth: 0.537662
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3403_29487",
    x: 0.511684,
    y: 4.45454,
    width: 249.836,
    height: 249.834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 22.2234,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3403_29487"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.94286
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.6325
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.32549 0 0 0 0 0.854902 0 0 0 0.83 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3403_29487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3403_29487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3403_29487",
    x: 83.0393,
    y: 74.1701,
    width: 124.203,
    height: 119.271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.2929,
    result: "effect1_foregroundBlur_3403_29487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3403_29487",
    x: 50.508,
    y: 74.1701,
    width: 125.187,
    height: 127.158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.2929,
    result: "effect1_foregroundBlur_3403_29487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3403_29487",
    x: 52.6689,
    y: 44.7783,
    width: 146.514,
    height: 139.613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.189,
    result: "effect1_foregroundBlur_3403_29487"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3403_29487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3403_29487"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 86,
    width: 78.8571,
    height: 78.8571,
    rx: 39.4286,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSphereresized);
export default __webpack_public_path__ + "static/media/Active Sphere resized.acf89e4eb4c4dec8f191ee64fff6144e.svg";
export { ForwardRef as ReactComponent };